module.exports = __webpack_public_path__ + "static/media/logout.d720866f.svg";